import React from "react";
import deviceIcons from "../device-icons"

function getDefaultIcon(deviceType){
    switch (deviceType){
        case "PDU":
            return "Construction/ConstructionWorker"
        case "GDU":
            return "Construction/TrackPerson"
        case "VDU":
        case "VEH":
        case "LVU":
            return "Construction/Car"
        case "APT":
            return "Construction/AccessPoint"
        case "SND":
        case "SAP":
        case "SPK":
        case "GCH":
        case "MST":
            return "Construction/ForkLift"
    }
}

function DeviceIcon({path, ...props}){
    const parts = /([^/]+)\/(.+)/.exec(path)
    return <div {...props}>{React.createElement(deviceIcons[parts[1]][parts[2]])}</div>
}

export {deviceIcons, DeviceIcon, getDefaultIcon}
